(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/error-boundary/error-boundary.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/error-boundary/error-boundary.js');
"use strict";

const {
  Component
} = React;
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch( 
  ) {
  }
  render() {
    const {
      errorComponent,
      children
    } = this.props;
    const {
      hasError
    } = this.state;
    if (hasError) {
      return errorComponent || React.createElement("h2", null, "N\xE5got har g\xE5tt tokigt h\xE4r..");
    }
    return children;
  }
}
svs.ticket_partner.sharedComponents.errorBoundary.ErrorBoundary = ErrorBoundary;

 })(window);